<template>
  <b-card no-body class="mt-6">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-colorblue"
      :data="projects"
    >
      <el-table-column
        label="Sr no"
        min-width="100px"
        prop="srno"
        sortable
      ></el-table-column>
      <el-table-column label="Name" min-width="220px" prop="name" sortable>
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <a href="#" class="avatar w-8 h-8 rounded-circle mr-3">
              <img alt="Image placeholder" :src="row.img" />
            </a>
            <b-media-body>
              <span class="font-medium  name mb-0 text-sm">{{
                row.title
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column label="Phone" prop="phone" min-width="140px" sortable>
      </el-table-column>

      <el-table-column label="Email" prop="email" min-width="140px" sortable>
      </el-table-column>

      <!-- <el-table-column
        label="Channels"
        min-width="190px"
        prop="channels"
        sortable
      >
        <base-input class="remove-mb0">
          <select class="form-control form-control-sm">
            <option disabled="true">Select Channel...</option>
            <option>Private Channel</option>
            <option>Public Channel</option>
          </select>
        </base-input>
      </el-table-column> -->

      <!-- <el-table-column 
        label="Status"
        min-width="130px"
        prop="statusaction"
        sortable
      >
        <template v-slot="{ row }">
          <base-button
            :class="`bg-${row.actioncolor}`"
            class="border-none cust-btn-xs"
            size="sm"
            >{{ row.statusaction }}</base-button
          >
        </template>
      </el-table-column> -->

      <!-- <el-table-column
        label="User Type"
        min-width="150px"
        prop="status"
        sortable
      >
        <template v-slot="{ row }">
          <badge class="badge-dot " type="">
            <i :class="`bg-${row.statusType}`"></i>
            <span class="status text-black">{{ row.status }}</span>
          </badge>
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="Users" min-width="190px">
        <div class="avatar-group">
          <a
            href="#"
            class="avatar avatar-sm rounded-circle"
            data-toggle="tooltip"
            data-original-title="Ryan Tompson"
          >
            <img alt="Image placeholder" src="img/theme/team-1.jpg" />
          </a>
          <a
            href="#"
            class="avatar avatar-sm rounded-circle"
            data-toggle="tooltip"
            data-original-title="Romina Hadid"
          >
            <img alt="Image placeholder" src="img/theme/team-2.jpg" />
          </a>
          <a
            href="#"
            class="avatar avatar-sm rounded-circle"
            data-toggle="tooltip"
            data-original-title="Alexander Smith"
          >
            <img alt="Image placeholder" src="img/theme/team-3.jpg" />
          </a>
          <a
            href="#"
            class="avatar avatar-sm rounded-circle"
            data-toggle="tooltip"
            data-original-title="Jessica Doe"
          >
            <img alt="Image placeholder" src="img/theme/team-4.jpg" />
          </a>
        </div>
      </el-table-column> -->

      <!-- <el-table-column
        label="Completion"
        prop="completion"
        min-width="240px"
        sortable
      >
        <template v-slot="{ row }">
          <div class="d-flex align-items-center">
            <span class="completion mr-2">%</span>
            <div>
              <base-progress :type="row.statusType" :value="row.completion" />
            </div>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column min-width="150px">
        <template v-slot="{ row }">
          <el-dropdown trigger="click" class="dropdown">
            <span class="btn btn-sm btn-icon-only text-light">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here</b-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column> -->
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import projects from "../emailer/components/projects";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      projects,
      currentPage: 1
    };
  }
};
</script>
